import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {
  PrivateFileUploadFieldComponent
} from '../../../../../components/form-inputs/private-file-upload-field/private-file-upload-field.component';
import {Subject, take, takeUntil} from 'rxjs';
import {TableComponent} from '../../../../../components/table/table.component';
import {TableFunctionList} from '../../../../../entities/table-function-list.entity';
import {
  PrivateAttachmentsApiService
} from '../../../../../components/form-inputs/private-file-upload-field/services/private-attachments-api.service';
import {
  ConfirmDeleteModalComponent
} from '../../../../../components/confirm-delete-modal/confirm-delete-modal.component';
import Process = Backend.App.Resources.Dashboard.QualityManagement.Process;
import PrivateAttachmentAttachableTypeEnum = Backend.App.Enums.Administration.Attachments.PrivateAttachmentAttachableTypeEnum;
import PrivateAttachmentTypeEnum = Backend.App.Enums.Administration.Attachments.PrivateAttachmentTypeEnum;
import PrivateAttachment = Backend.App.Resources.Dashboard.Administration.PrivateAttachment;
import ProcessVersion = Backend.App.Resources.Dashboard.QualityManagement.ProcessVersion;

@Component({
  selector: 'app-authenticated-quality-management-processes-documents',
  templateUrl: './documents.component.html',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    ModalModule,
    PrivateFileUploadFieldComponent,
    TableComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DocumentsComponent implements OnDestroy {
  public reloadTable$ = new EventEmitter<void>();
  @Input({required: true}) public process!: Process;
  @Input() public processVersion?: ProcessVersion;
  public uploadFile$: Subject<void> = new Subject<void>();
  public showFunctionList: TableFunctionList = {
    privateAttachmentDownload: rowData => {
      const data = rowData as PrivateAttachment;
      if (data && data.url) {
        window.open(data.url, '_blank', 'noopener,noreferrer');
      }
    },
  }
  protected onDestroy$: Subject<void> = new Subject<void>();
  public editFunctionList: TableFunctionList = {
    delete: rowData => {
      if (this.processVersion !== undefined) return;
      const documentToDelete = rowData as PrivateAttachment;

      this.bsModalService.show(ConfirmDeleteModalComponent, {
        initialState: {
          modelId: documentToDelete.id,
          dialogTranslation: this.translate.instant('authenticated.quality-management.processes.edit.documents.delete.title', {itemName: documentToDelete.filename}),
          successTranslation: this.translate.instant('authenticated.quality-management.processes.edit.documents.delete.success'),
          errorTranslation: this.translate.instant('authenticated.quality-management.processes.edit.documents.delete.error'),
          observable: this.privateAttachmentsApiService.delete(documentToDelete.id),
        }
      }).content?.deleteSuccess.pipe(
        takeUntil(this.onDestroy$),
        take(1)
      ).subscribe(() => {
        this.reloadTable$.emit();
        this.cdr.markForCheck();
      });
    },
    privateAttachmentDownload: rowData => {
      const data = rowData as PrivateAttachment;
      if (data && data.url) {
        window.open(data.url, '_blank', 'noopener,noreferrer');
      }
    },
  }
  protected readonly PrivateAttachmentAttachableTypeEnum = PrivateAttachmentAttachableTypeEnum;
  protected readonly PrivateAttachmentTypeEnum = PrivateAttachmentTypeEnum;

  public constructor(
    private readonly bsModalService: BsModalService,
    private readonly cdr: ChangeDetectorRef,
    private readonly privateAttachmentsApiService: PrivateAttachmentsApiService,
    private readonly translate: TranslateService,
  ) {
  }

  public fileUploadFinishedTrigger(): void {
    this.reloadTable$.emit();
  }

  public ngOnDestroy() {
    this.onDestroy$.next();
  }
}
